<template>
  <v-container>
    <v-row>
      <v-col lg="6">
        <v-card class="px-5 py-4">
          <v-row>
            <v-col lg="12">
              <h1 class="title font-weight-light black--text mb-5">
                <v-icon left color="black">mdi-book-plus</v-icon>
                Yeni Kullanıcı Rolü Ekle
                <v-divider class="mt-2"></v-divider>
              </h1>
              <h2 class="text-subtitle-1 font-weight-regular">
                1. Kullanıcı Rol Grubunu ve Rol Adını girin
              </h2>
              <v-select
                v-model="selectGroup"
                prepend-icon="mdi-select-group"
                :items="roleGroups"
                item-text="name"
                item-value="id"
                label="Grup Seç"
                persistent-hint
                single-line
              ></v-select>
              <v-text-field v-model="roleName" prepend-icon="mdi-tournament" class="font-weight-light" label="Rol adı belirtin" persistent-hint></v-text-field>
            </v-col>
            <v-col lg="12">
              <h2 class="d-flex align-center text-subtitle-1 font-weight-regular mb-2">
                2. Aşağıdaki Listeden Method Seçimi Yapın
                <v-spacer />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab x-small color="grey darken-4" dark v-on="on" v-bind="attrs" :loading="methodListSyncLoading" @click="getMethodList(true)">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Sync Method List</span>
                </v-tooltip>
              </h2>
              <p class="caption font-weight-light">
                Kullanıcı Rolü İçin Methodları İşaretleyin
              </p>
              <v-card-text class="px-0 py-3" v-for="(methods, controller) in methodsList" :key="controller" v-show="methods.length > 0">
                <h3 class="mb-2 grey--text text--darken-2">
                  <v-icon left>
                    mdi-script-outline
                  </v-icon>
                  {{ controller }}
                </h3>

                <v-chip-group v-model="selectMethodsList[controller]" column multiple>
                  <v-chip active-class="green white--text" v-for="(role, key) in methods" :key="key" :value="role">
                    <v-icon left>
                      mdi-check
                    </v-icon>
                    {{ role }}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-col>
            <v-col>
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" v-if="!editRoleID">
              <v-btn color="accent" elevation="2" :loading="groupsAddingStatus" @click="addUserRole">
                <v-icon>mdi-account-check</v-icon>
                Kullanıcı Rolünü Ekle
              </v-btn>
            </v-col>
            <v-col cols="12" v-else v-show="editRoleID">
              <v-btn dark class="mr-3" color="green darken-1" elevation="2" :loading="groupsAddingStatus" @click="editRole">
                <v-icon>mdi-account-check</v-icon>
                Grubu Düzenle
              </v-btn>
              <v-btn dark color="red darken-4" elevation="2" :loading="groupsAddingStatus" @click="resetRoleForm">
                <v-icon>mdi-account-check</v-icon>
                İptal
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col lg="6">
        <v-card class="px-5 pt-4">
          <v-row>
            <v-col lg="12">
              <div class="d-flex align-center py-0 px-0">
                <h1 class="title font-weight-light black--text">
                  <v-icon left color="black">mdi-format-list-text</v-icon>
                  Kullanıcı Rolleri Listesi
                </h1>
                <v-spacer></v-spacer>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small color="blue darken-2" dark v-bind="attrs" v-on="on" @click="grupEkleDialog = true" class="mr-2">
                      <v-icon dense left>mdi-plus-circle</v-icon>
                      Grup Ekle
                    </v-btn>
                  </template>
                  <span>Yeni Kullanıcı Grubu Ekle</span>
                </v-tooltip>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small color="green darken-2" dark v-bind="attrs" v-on="on" @click="grupDuzenleDialog = true">
                      <v-icon dense left>mdi-format-list-bulleted</v-icon>
                      Grup Listesi
                    </v-btn>
                  </template>
                  <span>Kullanıcı Grupları</span>
                </v-tooltip>
              </div>
              <v-divider class="mb-5 mt-2"></v-divider>

              <h2 class="text-subtitle-1 font-weight-regular mb-5">
                Kullanıcı Rolleri Listesi:
              </h2>
              <div id="user-roles-list">
                <div :key="group" v-for="(roles, group) in rolesList" class="mb-5">
                  <h3 class="text-body-1 font-weight-regular mb-4">
                    <v-icon size="15" color="grey darken-3">mdi-star-circle-outline</v-icon>
                    {{ group }}
                  </h3>
                  <v-tooltip bottom max-width="250" color="green" light :key="key" v-for="(role, key) in roles">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip v-on="on" v-bind="attrs" rounded :color="editRoleID === role.roleid ? 'green' : 'black'" small dark class="pl-5 mr-4 mb-3">
                        <div class="mr-3">
                          {{ role.rolename }}
                        </div>
                        <v-btn v-if="editRoleID !== role.roleid" small icon color="dark" @click="editRoleDetail(role.roleid)">
                          <v-icon size="15">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn v-else small icon color="dark" @click="resetRoleForm()">
                          <v-icon size="15">mdi-cancel</v-icon>
                        </v-btn>
                        <v-btn small icon color="dark" @click="deleteRole(role.roleid)">
                          <v-icon size="15">mdi-delete</v-icon>
                        </v-btn>
                      </v-chip>
                    </template>
                    <span :key="controller" v-for="(methodList, controller) in role.rolelist">
                      <i>{{ controller }}</i
                      >:
                      <span :key="key" v-for="(method, key) in methodList"> {{ method | toLower }}, </span>
                    </span>
                  </v-tooltip>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <template>
      <v-row justify="center">
        <!--    Group Add Dialog    -->
        <v-dialog v-model="grupEkleDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline title">
              <v-icon left color="black">mdi-plus</v-icon>
              Yeni Kullanıcı Grubu Oluştur
            </v-card-title>
            <v-card-text>
              <v-text-field label="Kullanıcı grubu adını girin" prepend-icon="mdi-account-arrow-right" hide-details v-model="roleGroupName"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="grupEkleDialog = false">
                <v-icon size="19" left>mdi-cancel</v-icon>
                İptal
              </v-btn>
              <v-btn v-if="!roleGroupID" color="green darken-1" text @click="addRoleGroup">
                <v-icon dense>mdi-plus</v-icon>
                Ekle
              </v-btn>
              <v-btn v-else color="green darken-1" text @click="editRoleGroup">
                <v-icon dense>mdi-plus</v-icon>
                Güncelle
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    ./Group Add Dialog    -->

        <!--    Group List Dialog    -->
        <v-dialog v-model="grupDuzenleDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline title">
              <v-icon left color="black">mdi-format-list-bulleted</v-icon>
              Role Grupları Listesi
            </v-card-title>
            <v-card-text>
              <v-list>
                <v-list-item :key="key" v-for="(group, key) in roleGroups">
                  <v-list-item-title>
                    {{ group.name }}
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-btn icon color="blue" @click="editRoleGroupDialog(group)">
                      <v-icon size="1.35rem">mdi-pen</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn icon color="red darken-2" @click="deleteRoleGroupConfirmation(group.id)">
                      <v-icon size="1.35rem">mdi-trash-can</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="grupDuzenleDialog = false">
                <v-icon size="19" left>mdi-cancel</v-icon>
                Kapat
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    ./Group List Dialog    -->

        <!--    ./Group Delete Confirmation Dialog    -->
        <v-dialog v-model="deleteRoleGroupDialog.model" persistent max-width="500">
          <v-card>
            <v-card-title class="headline red--text text--darken-4">
              <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
              Uyarı
            </v-card-title>
            <v-card-text>
              Grubu kaldırdığınızda ona bağlı olan
              <b>
                <u>tüm rol tanımlarıda</u>
              </b>
              gruptan kaldırılacaktır.
              <br />
              <br />Grubu kaldırmak istediğinizden emin misiniz ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="deleteRoleGroupDialog.model = false">İptal</v-btn>
              <v-btn color="green darken-1" text :loading="deleteRoleGroupDialog.loading" @click="deleteRoleGroup()">
                Evet
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    ./Group Delete Confirmation Dialog    -->
      </v-row>
    </template>
  </v-container>
</template>

<script>
import UserService from "@/services/UserService";
import { mapGetters, mapState } from "vuex";

export default {
  name: "DeveloperRoles",
  data() {
    return {
      groupsAddingStatus: false,
      grupEkleDialog: false,
      grupDuzenleDialog: false,
      roleName: "",
      roleGroupID: null,
      roleGroupName: "",
      selectGroup: "",
      selectMethodsList: {},
      editRoleID: "",
      methodListSyncLoading: false,
      deleteRoleGroupDialog: {
        id: null,
        model: false,
        loading: false
      }
    };
  },
  methods: {
    methodsListSet() {
      /**
       * Role listesini kullanılabilir bir biçim için ayarla
       */
      this.selectMethodsList = {};
      Object.keys(this.methodsList).forEach(controller => {
        this.selectMethodsList[controller] = [];
      });
    },
    addRoleGroup() {
      const { roleGroupName } = this;
      this.$store.dispatch("User/UserRoles/addRoleGroup", { roleGroupName }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Rol grubu başarıyla eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.resetRoleGroupForm();
          this.grupEkleDialog = false;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    /**
     * Sisteme yeni rol eklemesi yap
     */
    addUserRole() {
      const { selectGroup, roleName, selectMethodsList } = this;
      this.$store.dispatch("User/UserRoles/addUserRole", { selectGroup, roleName, selectMethodsList }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Kullanıcı rolü başarıyla eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.selectGroup = "";
          this.roleName = "";
          this.methodsListSet();
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    /**
     * Herhangi bir rolü düzenlemek için
     * rol detayını getir ve forma geçir
     *
     * @params {Number}
     */
    editRoleDetail(roleId) {
      new Promise(resolve => {
        UserService.roleDetail(roleId)
          .then(res => {
            if (res.status === 200) {
              this.roleName = res.data.name;
              this.selectGroup = res.data.group;
              this.editRoleID = res.data.id;
              Object.entries(res.data.rolelist).forEach(roleList => {
                this.$set(this.selectMethodsList, roleList[0], roleList[1]);
              });
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
            resolve(res);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },
    /**
     * Rol düzenlemesi yap
     */
    editRole() {
      const { editRoleID, roleName, selectGroup, selectMethodsList } = this;
      this.$store
        .dispatch("User/UserRoles/editRole", {
          editRoleID,
          roleName,
          selectGroup,
          selectMethodsList
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Kullanıcı rolü başarıyla güncellenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.resetRoleForm();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
    },
    /**
     * Rol formunu resetle
     */
    resetRoleForm() {
      this.roleName = "";
      this.selectGroup = "";
      this.editRoleID = "";
      this.methodsListSet();
    },
    /**
     * Rol group formunu resetle
     */
    resetRoleGroupForm() {
      this.roleGroupID = null;
      this.roleGroupName = "";
    },
    /**
     * Herhangi bir rolü sil
     */
    deleteRole(roleId) {
      new Promise(resolve => {
        UserService.deleteRole(roleId)
          .then(res => {
            if (res.status === 200) {
              this.$store.dispatch("User/UserRoles/getRolesList");
              this.$snotify.success("Kullanıcı rolü başarıyla silinmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
            resolve(res);
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    editRoleGroupDialog(group) {
      const { id, name } = group;
      this.roleGroupID = id;
      this.roleGroupName = name;
      this.grupEkleDialog = true;
    },

    editRoleGroup() {
      const { roleGroupID, roleGroupName } = this;

      this.$store
        .dispatch("User/UserRoles/editRoleGroup", { roleGroupID, roleGroupName })
        .then(({ status, data }) => {
          if (status === 200) {
            this.$snotify.success("Kullanıcı rol grubu başarıyla güncellenmiştir.", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.resetRoleGroupForm();
            this.grupEkleDialog = false;
          } else {
            this.$snotify.error(data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .finally(() => {
          this.deleteRoleGroupDialog.loading = false;
        })
        .catch(() => {
          this.deleteRoleGroupDialog.loading = false;
        });
    },

    deleteRoleGroupConfirmation(groupId) {
      this.deleteRoleGroupDialog.id = groupId;
      this.deleteRoleGroupDialog.model = true;
    },

    deleteRoleGroup() {
      const { id } = this.deleteRoleGroupDialog;
      this.deleteRoleGroupDialog.loading = true;

      this.$store
        .dispatch("User/UserRoles/deleteRoleGroup", id)
        .then(({ status, data }) => {
          if (status === 200) {
            this.$snotify.success("Kullanıcı rol grubu başarıyla sistemden kaldırılmıştır.", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.deleteRoleGroupDialog.model = false;
          } else {
            this.$snotify.error(data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .finally(() => {
          this.deleteRoleGroupDialog.loading = false;
        })
        .catch(() => {
          this.deleteRoleGroupDialog.loading = false;
        });
    },

    getMethodList(sync) {
      /**
       * Sistem Methodlarını Senkronize et
       */
      this.methodListSyncLoading = true;
      this.$store
        .dispatch("Controller/getMethodsList", { sync })
        .then(() => {
          this.methodsListSet();
          this.methodListSyncLoading = false;
        })
        .catch(() => {
          this.methodListSyncLoading = false;
        });
    }
  },
  computed: {
    ...mapGetters({
      roleGroups: "User/UserRoles/getUserRolesGroups"
    }),
    ...mapState({
      methodsList: state => state.Controller.methodsList,
      rolesList: state => state.User.UserRoles.rolesList
    })
  },
  filters: {
    toLower(val) {
      return val.toLowerCase();
    }
  },
  created() {
    /**
     * Rol Listesini Getir
     */
    this.$store.dispatch("User/UserRoles/getRolesList");

    /**
     * Rol Gruplarını Getir
     */
    this.$store.dispatch("User/UserRoles/getRolesGroups");

    /**
     * Sistem Methodlarını Getir
     */
    this.getMethodList(false);

    /**
     * BreadCrumbs Ayarla
     */
    this.$store.commit("setBreadCrumbs", [
      {
        text: "Geliştirici",
        link: "/developer"
      },
      {
        text: "Kullanıcı Rollerini Ekle veya Kaldır",
        link: "/"
      }
    ]);
  },

  watch: {
    grupEkleDialog(value) {
      if (!value) {
        this.resetRoleGroupForm();
      }
    }
  }
};
</script>

<style scoped>
#user-roles-list {
  display: flex;
  flex-wrap: wrap;
}

#user-roles-list > div {
  flex-basis: 50%;
}
</style>
